module.exports = __webpack_public_path__ + "img/stonewall.1d6007fc.png";